var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2C6.47724 2 2 6.47723 2 12.0001C2 17.5231 6.47724 22 11.9999 22C17.5232 22 22 17.5231 22 12.0001C22 6.47759 17.5232 2.00048 11.9998 2.00048L11.9999 2ZM16.5858 16.423C16.4067 16.7167 16.0222 16.8099 15.7285 16.6295C13.3806 15.1954 10.4249 14.8706 6.94403 15.6659C6.6086 15.7423 6.27424 15.5321 6.19782 15.1966C6.12104 14.861 6.33037 14.5266 6.66663 14.4502C10.4759 13.5799 13.7434 13.9546 16.3793 15.5656C16.673 15.7459 16.7662 16.1292 16.5858 16.423ZM17.8098 13.7001C17.5841 14.0669 17.1041 14.1827 16.7375 13.957C14.0495 12.3048 9.95214 11.8263 6.77279 12.7914C6.36046 12.916 5.92496 12.6836 5.79982 12.272C5.67563 11.8596 5.90812 11.425 6.31974 11.2996C9.95142 10.1976 14.4663 10.7314 17.5531 12.6283C17.9197 12.854 18.0355 13.3339 17.8098 13.7001ZM17.9149 10.8647C14.692 8.95032 9.37454 8.7743 6.29741 9.70825C5.80328 9.85811 5.28073 9.57916 5.13099 9.08502C4.98125 8.59064 5.25995 8.06844 5.75444 7.91821C9.28677 6.84587 15.1589 7.05305 18.8695 9.2559C19.3149 9.51969 19.4606 10.0937 19.1967 10.5376C18.934 10.982 18.3584 11.1286 17.9154 10.8647H17.9149Z",
    fill: "#1ED760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.d78baf30.svg";
export { ForwardRef as ReactComponent };